import { useEffect } from 'react';

import { supabaseClient } from '@auth-v2';
import * as Sentry from '@sentry/react';

import { subscribeToNotifications } from '@data';
import { queryClient, getNotificationsKey, getThreadMessageNotificationsKey } from '@queries';

/**
 * This hook only fires on delete or insert, we manually set the cache on update
 */
export const useNotificationSubscription = () => {
    useEffect(() => {
        const sub = subscribeToNotifications(supabaseClient, async (payload) => {
            const sourceUserId = payload.new?.source_user_id ?? payload.old?.source_user_id;

            if (!sourceUserId) {
                Sentry.captureMessage('Missing source_user_id in notification subscription payload', {
                    level: 'warning',
                    extra: {
                        payload,
                        eventType: payload.eventType,
                        table: payload.table,
                        schema: payload.schema,
                    },
                });
                queryClient.invalidateQueries({ queryKey: getThreadMessageNotificationsKey() });
                return;
            }
            queryClient.invalidateQueries({ queryKey: getThreadMessageNotificationsKey() });
            queryClient.invalidateQueries({
                predicate: (query) =>
                    getNotificationsKey(sourceUserId).every((piece) => query.queryKey.includes(piece)),
            });
        });

        return () => {
            sub.unsubscribe();
        };
    }, [supabaseClient]);
};
